import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import { getFixedDropdownArr } from '../../../utils/packagesUtils';
import { BASIC_PACKAGE_ID } from '../../../utils/packagesUtils/constants';
import { getPackageById } from '../../../reducers/packages';
import { updateQuantity } from '../../../actions/packages';

import './style.scss';

class GigQuantity extends React.Component {

    constructor() {
        super();

        this.onSelectChange = this.onSelectChange.bind(this);
    }

    onSelectChange(e) {
        const { onChange } = this.props,
            { value } = e.target,
            numberedValue = Number(value);

        onChange(numberedValue);
    }

    render() {
        const { quantity, price } = this.props;
        const { currencyConverter } = this.context;

        return (
            <div className="gig-quantity">
                <b><I18n k={'gig_page_perseus.packages.gig_quantity'}/></b>
                <select value={quantity} onChange={this.onSelectChange}>
                    {
                        getFixedDropdownArr().map((val) => <option key={val} value={val}>{`${val} (${currencyConverter.convert(val * price)})`}</option>)
                    }
                </select>
            </div>
        );
    }
}

GigQuantity.propTypes = {
    onChange: PropTypes.func,
    quantity: PropTypes.number,
    price: PropTypes.number
};

GigQuantity.defaultProps = {
    onChange: () => true
};

GigQuantity.contextTypes = {
    currencyConverter: PropTypes.object
};

const mapDispatchToProps = (dispatch) => ({
    onChange: (quantity) => {
        dispatch(updateQuantity({quantity}));
    }
});

const mapStateToProps = ({ packages }) => {
    const packageData = getPackageById(packages, BASIC_PACKAGE_ID);

    return {
        ...packageData,
        quantity: packages.quantity
    };
};

export { GigQuantity };

export default connect(mapStateToProps, mapDispatchToProps)(GigQuantity);
